import qs from 'qs';

import { RouterLink } from '../../generic/Link';
import type { AuthPage } from '../index';

type TextMap = {
  to: string;
  link: string;
  text: string;
};

type SignInSignUpToggleProps = {
  page: AuthPage;
  email: string;
};

//  Map for determining which text to render.
const textMap: Record<AuthPage, TextMap> = {
  login: {
    to: '/auth/register',
    text: 'No account?',
    link: 'Sign up for FOSSA',
  },
  register: {
    to: '/auth/login',
    text: 'Already have an account?',
    link: 'Sign in',
  },
};

/**
 * Helper to append the user's email as a query param.
 * This improves the UX as the user won't need to re-type their email.
 *
 * @param {string} to - Where to link to.
 * @param {string} email - The user's email (if it exists).
 */
function appendEmailParam(to: string, email?: string): string {
  return email
    ? `${to}?${qs.stringify({ email })}`
    : to;
}

/**
 * Renders the link to "toggle" between signing up and logging in.
 */
const SignInSignUpToggle = ({ page = 'login', email }: SignInSignUpToggleProps) => {
  const { link, to, text } = textMap[page];
  return (
    <div className="fossa-auth__page-link-toggle">
      {text}
      {' '}
      <RouterLink to={appendEmailParam(to, email)}>
        {link}
      </RouterLink>
    </div>
  );
};

export default SignInSignUpToggle;
